import React, { Component } from "react";
import { connect, ConnectedProps } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router";
import { NavLink } from "react-router-dom";
import { bindActionCreators, Dispatch } from "redux";
import styled from "styled-components";
import CrossIcon from "sweet-web/components/icons/CrossIcon";
import TextLogoIcon from "sweet-web/components/icons/TextLogoIcon";
import CreateListing from "sweet-web/components/TopBar/CreateListing";
import { colors } from "sweet-web/lib/styles";
import { RootState } from "sweet-web/redux";
import { LogOut } from "sweet-web/redux/app/actions";
import { toggleMenu } from "sweet-web/redux/app/actions";
import * as selectors from "sweet-web/redux/selectors";

const MenuBar = styled.div<{ visible: boolean }>`
  position: fixed;
  top: 0;
  bottom: 0;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
  background-color: ${colors.white};
  width: 160px;
  transition: all 150ms cubic-bezier(0.21, 0.94, 0.64, 0.99);
  z-index: 101;
  ${props => {
    if (props.visible) {
      return `right: 0;`;
    } else {
      return `right: -180px;`;
    }
  }}
  @media screen and (min-width: 600px) {
    display: none;
  }
`;

const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-start;
  padding-top: 5px;
  width: 100%;
`;

const Link = styled(NavLink)`
  width: 100%;
  padding: 10px 20px 10px 20px;
  outline: none;
  border: none;
  border-bottom: 1px solid ${colors.lighterGray};
  color: ${colors.gray};
  background: transparent;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  text-decoration: none;
  &:last-child {
    border: none;
  }
`;

const LegalLink = styled(NavLink)`
  width: 100%;
  padding: 10px 20px 10px 20px;
  outline: none;
  border: none;
  border-bottom: 1px solid ${colors.lighterGray};
  color: ${colors.gray};
  background: transparent;
  font-size: 12px;
  font-weight: 500;
  text-align: center;
  text-decoration: none;
  &:last-child {
    border: none;
  }
`;

const ExitButton = styled.button`
  outline: none;
  border: none;
  background: transparent;
  padding: 12px 20px;
`;

const BottomSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
`;

const activeStyle = {
  color: colors.primary
};

type Props = RouteComponentProps & ConnectedProps<typeof connector>;

const MobileMenu: React.FC<Props> = props => {
  const { loggedIn, userType, menuOpen } = props;

  const closeMenu = () => props.toggleMenu(false);

  return (
    <MenuBar visible={menuOpen}>
      <TopSection>
        <ExitButton onClick={() => props.toggleMenu(false)}>
          <CrossIcon size={24} color={colors.lightGray} />
        </ExitButton>
        {loggedIn && userType === "VENUE" && (
          <Link
            to="/"
            activeStyle={activeStyle}
            exact={true}
            onClick={closeMenu}
          >
            Dashboard
          </Link>
        )}
        {userType !== "VENUE" && (
          <Link
            to="/"
            activeStyle={activeStyle}
            exact={true}
            onClick={closeMenu}
          >
            Discover
          </Link>
        )}
        {loggedIn && (
          <Link to="/c" activeStyle={activeStyle} onClick={closeMenu}>
            Inbox
          </Link>
        )}
        {loggedIn && userType === "VENUE" && (
          <Link to="/listings" activeStyle={activeStyle} onClick={closeMenu}>
            Listings
          </Link>
        )}
        {loggedIn && (
          <Link to="/me" activeStyle={activeStyle} onClick={closeMenu}>
            Account
          </Link>
        )}
        {loggedIn && (
          <Link to="/reset" activeStyle={activeStyle} onClick={closeMenu}>
            Log Out
          </Link>
        )}
        {!loggedIn && (
          <Link to="/login" activeStyle={activeStyle} onClick={closeMenu}>
            Login
          </Link>
        )}
        {!loggedIn && (
          <Link to="/join" activeStyle={activeStyle} onClick={closeMenu}>
            Join
          </Link>
        )}
        {!loggedIn && (
          <Link to="/list" activeStyle={activeStyle} onClick={closeMenu}>
            List Venue
          </Link>
        )}
      </TopSection>
      <BottomSection>
        <LegalLink to="/terms" activeStyle={activeStyle} onClick={closeMenu}>
          Terms of Use
        </LegalLink>
        <LegalLink to="/privacy" activeStyle={activeStyle} onClick={closeMenu}>
          Privacy Policy
        </LegalLink>
        <TextLogoIcon
          size={24}
          color={colors.primary}
          style={{ marginTop: 20, marginBottom: 20 }}
        />
      </BottomSection>
    </MenuBar>
  );
};

const mapState = (state: RootState) => ({
  loggedIn: selectors.loggedIn(state),
  userType: selectors.userType(state),
  menuOpen: selectors.menuOpen(state)
});
const mapDispatch = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      toggleMenu,
      LogOut
    },
    dispatch
  );
const connector = connect(mapState, mapDispatch);

export default withRouter(connector(MobileMenu));
